import { useContext, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getExpenseDetails } from "../../../../services/expenses";
import { useCancelExpenseRecurrenceMutation } from "../../../../hooks/api/mutations/expenses";
import { ToastContext } from "../../../../hooks/context";

const useExpenseDetails = () => {
  const params = useParams();
  const triggerToast = useContext(ToastContext);
  const [isReviewExpense, setIsReviewExpense] = useState(false);
  const [isConfirmingCancelRecurrence, setIsConfirmingCancelRecurrence] =
    useState(false);

  const { isLoading: isFetchingExpenseDetails, data: expenseDetails } =
    useQuery(["getExpenseDetails", params.id], () =>
      getExpenseDetails(params.id).then((res) => res?.data?.data),
    );

  const { mutate: cancelRecurrence, isLoading: isCancellingRecurrence } =
    useCancelExpenseRecurrenceMutation({ id: params.id });

  const handleCancelRecurrence = () => {
    cancelRecurrence(params.id, {
      onSuccess: (res) => {
        triggerToast(
          res?.data?.detail || "Recurrence cancelled successfully",
          "success",
        );
        setIsConfirmingCancelRecurrence(false);
      },
    });
  };

  return {
    isFetchingExpenseDetails,
    expenseDetails,
    isReviewExpense,
    setIsReviewExpense,
    handleCancelRecurrence,
    isCancellingRecurrence,
    isConfirmingCancelRecurrence,
    setIsConfirmingCancelRecurrence,
  };
};
export default useExpenseDetails;
